import { getField, updateField } from "vuex-map-fields";
import stakeholderService from "../../services/stakeholderService";

const state = {
  filteredStakeholders: []
};

const getters = {
  filteredStakeholders: state => {
    return state.filteredStakeholders;
  },
  getField
};

const actions = {
  updateFilteredStakeholders({ commit }, filteredStakeholders) {
    commit("UPDATE_FILTERED_STAKEHOLDERS", filteredStakeholders);
  },
  fetchStakeholders({ commit }) {
    stakeholderService.fetchStakeholders().then(stakeholders => {
      commit("UPDATE_FILTERED_STAKEHOLDERS", stakeholders);
    });
  },
};

const mutations = {
  updateField,
  UPDATE_FILTERED_STAKEHOLDERS(state, stakeholders) {
    state.filteredStakeholders = stakeholders;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
